import { render } from "./message_room.vue?vue&type=template&id=ebf4838c"
import script from "./message_room.vue?vue&type=script&lang=js"
export * from "./message_room.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__